<!--
@name 硕士教育-房地产经济与管理硕士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          房地产经济与管理学专业硕士专业是一门专注于房地产经济与管理领域的研究和
          教育的专业。该专业旨在培养具备房地产经济与管理专业知识和技能的高级人才，以
          应对国内外日益复杂的房地产市场。
        </div>
        <div class="selector-indent">
          该专业的课程设置涵盖了房地产经济、房地产市场分析、房地产投资与融资、房
          地产开发与管理等方面的内容。学生将学习到房地产市场的运作机制、投资决策方
          法、项目开发管理技巧等知识。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">卓越资质</p>
          <p>
            AACSB认证的全球顶尖精英商校，中国教育部涉外信息监管网可查。
          </p>
          <p class="advantage-title">正规保障</p>
          <p> 免考试，面试审核制入学，校本部直招，法国校本部学籍注册，中国国内在职研读。</p>
          <p class="advantage-title">实战体系</p>
          <p>
            立足本土实用导向的课程设计，“课堂讲授+案例分析+共创工作坊+沉浸式研学”多种形式
            相结合，提升理论应用、分析和解决实际管理问题的能力。</p>
          <p class="advantage-title">强大师资</p>
          <p>
            法国布雷斯特高等商学院副教授以上级别团队及国内一线高校教授亲自授课，正本清源。
            专业课部分由行业专家和标杆房企高管授课，实操落地。
          </p>
          <p class="advantage-title">广阔平台</p>
          <p>庞大的校友网络、专家智库、政府与金融机构链接等，搭建高端商务交流、资源整合的优质平台。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养方式</div>
        <div class="selector-indent">
          倾力培养具备房地产金融与资本运营思维，能够准确把握房地产行业
          规律，同时具有战略创新意识和行业发展视野的房地产企业高级管理人才；
        </div>
        <div class="selector-indent">加速培养围绕经营指标，在投资拿地、产品决策、销售回款、成本控
          制、工程品质、现金流安全等业务关键环节能够快速整合资源、组织
          跨专业协同作战的优秀房地产项目管理人才；
        </div>
        <div class="selector-indent">重点培养既能读懂老板，坚定执行董事会的投资意图，亦能以独特的
          影响力和决断力指挥团队冲锋陷阵、所向披靡的卓越房地产项目操盘手。
        </div>
      </div>
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程简介</div>
        <p>围绕新时期优秀房地产项目管理人才应具备的三大核心功底：投融资能力、经营能力、项目管理能力进行课程设计。</p>
        <img src="@/assets/images/personRain/mreem-course01.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/mreem-course02.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/mreem-course03.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/mreem-course04.png" alt="" class="course-img"/>
        <img src="@/assets/images/personRain/mreem-course05.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">师资介绍</div>
        <p>谢志华：
          中国房地产管理咨询业先行者，中国房地产战略创新与管理升级布道者，国有房企市场化改
          革与发展总顾问师，中海/绿地/华润/世茂/中梁/金科/中铁建/中铁/华侨城/康桥/华宇/等多家
          百强地产特聘顾问。</p>
        <p>程江：
          程老师历任华夏幸福大学专业力学院负责人、万达学院教学副总、鸿坤地产学院院长等职，
          在地产领域领导力培养、经理人打造、企业大学建设与运营等方面有着极其丰富的经验。</p>
        <p>黄明玉：
          资深房地产项目投资开发专家，曾任蓝城、绿城集团项目总经理，清华大学、浙江工业大学 、
          浙江经贸大学房地产总裁班客座教授。资深房地产项目实战操盘手，拥有近30年房地产项
          目开发经验，参与开发项目近二十个。曾主持开发“西子城市花园”、“林语别墅”、“阿
          卡迪亚”、“长赢·御龙湾”等多个成功案例。</p>
        <p>凌云：
          凌云老师，曾任TOP3房企区域投资负责人，集团100强讲师，现任规模房企集团战略投资
          中心负责人。10余年百强房企投拓经历，具备土地一级开发、城改、产业勾地、收并购、招
          拍挂、法拍等多种类型丰富的投资实战经验。</p>
        <p>刘辉：
          资深房地产设计顾问、专家。建筑学专业本科毕业，资深地产开发研究员，房地产规划设计专
          家。现为深圳某设计咨询公司总设计师。</p>
        <p>高剑：
          曾任万科集团深圳区域本部市场营销部总策划师；万科集团建筑研究中心副总策划师。万科集
          团营销专家委员会委员；万科集团建筑与环境艺术委员会委员：曾任深圳万科地产公司广告营
          销主管、销售部经理助理，销售部副总经理，华南区域管理中心营销部总经理，集团的灵巧
          制导专家小组和海燕小组成员。</p>
        <p>吕子明：
          房地产工程项目管理实战专家，现任某标杆房企工程项目负责人，万科星级讲师，曾任职于
          鲁能集团、万科集团、中国金茂等标杆房地产企业。</p>
        <p>刘祥：
          江苏海洋大学工业与民用建筑专业工学学士，南京大学企业成长与投资专业工商管理硕士，
          高级工程师国家注册监理工程师，30年一线建筑工程与成本管理经历。曾任龙湖地产工程
          总，负责工程与施工成本，协助招标。</p>
        <p>武晨：
          房地产财务管理实战专家，经济学硕士，近20年财务从业经历，原TOP20地产财务高管，
          CPA（注册会计师)，CTA（注册税务师)，CPV（注册资产评估师)CMA（注册管理会
          计师)。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="@/assets/images/personRain/mba-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科或同等学历</p>
        <p>专科毕业，拥有三年及以上管理经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <!--      <div class="down-load">-->
      <!--        <p>相关资料下载</p>-->
      <!--        <p class="open-pdf" @click="openPdf">房地产经济与管理硕士</p>-->
      <!--      </div>-->
      <!--      <div style="clear:both;" />-->
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 相关资料下载 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'EduGjsw',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    // openPdf() {
    //   window.open('http://cdn.yzvet.com/group1/M00/3F/9E/wKgCEmfD2laAX_GHAKkruA94R9w475.pdf', '_blank');
    // }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduGjsw.vue